// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Rating, Stack, SvgIcon, Typography } from '@mui/material';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './GoogleRating.module.scss';
import { icons } from '~/assets';

type Props = {
  rate: number;
  onSeeAll: () => void;
};

const cx = classNames.bind(styles);

const GoogleRating = (props: Props) => {
  //#region Destructuring Props
  const { rate, onSeeAll } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack direction={'row'} alignItems={'center'} spacing={6} className={cx('container')}>
      <Stack direction={'row'}>
        <img src={icons.commonIconGoogle} alt={t('common_alt_img')} />
      </Stack>

      <Stack direction={'column'}>
        <Stack direction={'row'} alignItems={'center'}>
          <Typography className={cx('rating')}>{rate}</Typography>

          <Rating
            readOnly
            defaultValue={rate}
            precision={1}
            icon={
              <SvgIcon>
                <image href={icons.commonIconStarActive} width='24' height='24' />
              </SvgIcon>
            }
            emptyIcon={
              <SvgIcon>
                <image href={icons.commonIconStarUnactive} width='24' height='24' />
              </SvgIcon>
            }
          />
        </Stack>

        <Typography component={'span'} className={cx('buttonSeeAll')} onClick={onSeeAll}>
          {t('common_button_see_all')}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default GoogleRating;
